import { ReloadIcon } from '@radix-ui/react-icons';

const ReconnectingAlert = () => {
    return (
        <div className="absolute top-1 right-1 z-10 bg-surface border border-divider rounded-lg shadow-lg p-4 flex items-center justify-center gap-2">
            <p className="font-bold">Reconnecting</p>
            <ReloadIcon className="animate-spin" />
        </div>
    );
};

export default ReconnectingAlert;
